/**
 * KAN-846: вход в приложение менеджера по логину (почта или телефон) и
 * паролю. Успех: кеш прошлого пользователя очищается, аккаунт добавляется к
 * вошедшим и становится активным (startAuthSession, KAN-925), затем onSuccess. Ошибка: текст backend или общий
 * "Неверный логин или пароль".
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { passwordLoginApi } from '@/services/api/passwordLogin';
import { startAuthSession } from '@/lib/authSession';
import { extractErrorMessage } from '@/lib/extractErrorMessage';

export const PASSWORD_LOGIN_ERROR = 'Неверный логин или пароль';

export function usePasswordLogin(onSuccess: () => void) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    // KAN-834: запрос входа идёт без Authorization (apiClient). KAN-925: вошедшие
    // аккаунты до входа не выходят, вход добавляет аккаунт.
    mutationFn: ({ login, password }: { login: string; password: string }) =>
      passwordLoginApi.login(login.trim(), password),
    onSuccess: (data) => {
      queryClient.clear();
      startAuthSession(data.access, data.refresh, data.user);
      onSuccess();
    },
  });
  return {
    submit: (login: string, password: string) => mutation.mutate({ login, password }),
    pending: mutation.isPending,
    error: mutation.isError ? extractErrorMessage(mutation.error, PASSWORD_LOGIN_ERROR) : null,
  };
}
